import { ApButtonIcon } from '@alixpartners/ui-components';
import React from 'react';
import {
	Backdrop,
	ModalContainer,
	ModalHeader,
} from './ModuleInfoModal.styles.js';

const ModuleInfoModal = ({ handleClose, children, title }) => {
	return (
		<Backdrop>
			<ModalContainer>
				<ModalHeader>
					<div>{title}</div>
					<ApButtonIcon
						title="Close"
						iconName="close"
						onClick={() => handleClose()}
					/>
				</ModalHeader>
				{children}
			</ModalContainer>
		</Backdrop>
	);
};

export default ModuleInfoModal;
